export default "__VITE_ASSET__00ec84dc__"